import * as React from 'react';
import type { Trip } from 'contracts/tracking-v2/trips';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardPortal,
  HoverCardContent,
} from 'components/ui/hover-card';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<typeof HoverCardContent> &{
  invoices: Trip['invoices'];
}

export const TripInvoiceNumbersHoverCard = ({ invoices, className, ...props }: Props) => {
  return (
    <HoverCard>
      <HoverCardTrigger onClick={(e) => e.stopPropagation()}>
        <div
          className={
            'border w-max px-1 h-6 bg-slate-50 flex justify-center items-center rounded-sm text-gray-600'
          }
        >
          {invoices.length}
        </div>
      </HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent {...props} className={cn('z-50', className)}>
          {invoices.map((invoice) => {
            const { id, infnfeIdeNnf, infnfeIdeSerie, destinationCity } = invoice;
            const origin = [destinationCity?.name, destinationCity?.uf].join('/');

            return (
              <div
                key={id}
                className={cn(
                  'flex flex-col [&:not(:last-child)]:border-b border-slate-200 py-3 px-2 gap-1',
                )}
              >
                <div className={'font-GilroySemibold text-black text-xs'}>
                  NF {[infnfeIdeNnf, infnfeIdeSerie].join('-')}
                </div>
                <div className={'font-sans text-slate-600 text-xs'}>{origin}</div>
              </div>
            );
          })}
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
};